import { render, staticRenderFns } from "./create-bulk-payment.vue?vue&type=template&id=2f48e7e4&scoped=true"
import script from "./create-bulk-payment.vue?vue&type=script&lang=js"
export * from "./create-bulk-payment.vue?vue&type=script&lang=js"
import style0 from "./create-bulk-payment.vue?vue&type=style&index=0&id=2f48e7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48e7e4",
  null
  
)

export default component.exports